"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = ChatCreateOptions;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _core = require("@material-ui/core");

var _Image = _interopRequireDefault(require("@material-ui/icons/Image"));

var _Description = _interopRequireDefault(require("@material-ui/icons/Description"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var StyledMenu = (0, _styles.withStyles)({
  paper: {
    border: '1px solid #d3d4d5'
  }
})(function (props) {
  return /*#__PURE__*/_react["default"].createElement(_core.Menu, _extends({
    elevation: 4,
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    }
  }, props));
});

function ChatCreateOptions(_ref) {
  var anchorEl = _ref.anchorEl,
      onClose = _ref.onClose,
      onChange = _ref.onChange,
      labels = _ref.labels;

  var handleClick = function handleClick(item) {
    return function (event) {
      onChange(item);
    };
  };

  return /*#__PURE__*/_react["default"].createElement(StyledMenu, {
    id: "customized-menu",
    anchorEl: anchorEl,
    keepMounted: true,
    open: Boolean(anchorEl),
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    onClick: handleClick('image')
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_Image["default"], {
    fontSize: "small"
  })), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
    primary: labels.image
  })), /*#__PURE__*/_react["default"].createElement(_core.MenuItem, {
    onClick: handleClick('doc')
  }, /*#__PURE__*/_react["default"].createElement(_core.ListItemIcon, null, /*#__PURE__*/_react["default"].createElement(_Description["default"], {
    fontSize: "small"
  })), /*#__PURE__*/_react["default"].createElement(_core.ListItemText, {
    primary: labels.doc
  })));
}